<template>
  <div class="nav-header bg-header w-full">
    <Disclosure
      id="nav"
      :key="searchMenuKey"
      as="nav"
      class="bg-header h-15 p-2 lg:p-0 lg:h-auto lg:max-w-screen-xl lg:mx-auto">
      <div class="custom-header p-4 px-2 lg:px-0">
        <div class="relative flex justify-between">
          <div class="flex flex-1 items-center justify-center lg:items-stretch lg:justify-start">
            <div class="hidden lg:flex flex-shrink-0 items-center">
              <RouterLink to="/"><img class="logo ml-2 pr-4 max-h-8" :src="logo" alt="logo" /></RouterLink>
            </div>
            <div class="flex lg:hidden z-50">
              <RouterLink to="/"><img class="logo" alt="logo" :src="logo_mobile" /></RouterLink>
            </div>
          </div>
          <div class="absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0">
            <LanguageMenu />
            <button
              v-if="userStore.isXs2Ticket"
              class="relative ml-2 pl-2 border-l lg:pl-4 lg:flex-shrink-0"
              @click="logout()">
              <span class="flex gap-2">
                <ArrowLeftOnRectangleIcon class="w-6 text-header-icon" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </Disclosure>
  </div>
</template>

<script setup>
import { LanguageMenu } from "./menu";

import { Disclosure } from "@headlessui/vue";
import { ArrowLeftOnRectangleIcon } from "@heroicons/vue/24/outline";

import brandconfig from "@/brandconfig";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/store/user.js";

const logo = brandconfig.LOGO;
const logo_mobile = brandconfig.LOGO_MOBILE;
const searchMenuKey = ref(0);
const userStore = useUserStore();
const router = useRouter();

const logout = () => {
  delete localStorage.bookingId;
  router.push("/xs2ticket").then(() => {
    userStore.signOut();
  });
};
</script>

<style scoped>
.logo {
  height: 30px;
}
</style>
